export class ResizeTierAction {

  constructor(
    public readonly points: Array<any>,
    public readonly tierCustomId: number
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/ResizeTierAction.ts